// extracted by mini-css-extract-plugin
export default {"committee":"style_committee__mIs1P","wrapper":"style_wrapper__DOKqt","image":"style_image__Rjt7j","title":"style_title__fUUU3","content":"style_content__1YhN2"};